export enum ECartType {
  Cart = 'cart',
  ClickAndCollect = 'clickAndCollect',
}
